import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getFileTypeListSaga = createAction(
  "GET_FILE_TYPES",
  ({ payload, params }: SagaActionParams<Type.FileTypeDto[]>) => ({
    payload,
    url: "/api/admin/adminentityfiletypes" + (params ? params : ""),
  })
);
export const getFileTypeDetailsSaga = createAction(
  "GET_FILE_TYPES_DETAILS",
  ({ payload, id }: SagaActionParams<Type.FileTypeDetailDto>) => ({
    payload,
    url: "/api/admin/adminentityfiletypes/" + id,
  })
);
export const createFileTypeSaga = createAction(
  "CREATE_FILE_TYPES",
  ({ payload, body }: SagaActionParams<Type.FileTypeDto>) => ({
    payload,
    url: "/api/admin/adminentityfiletypes",
    body,
  })
);
export const updateFileTypeSaga = createAction(
  "UPDATE_FILE_TYPES",
  ({ payload, id, body }: SagaActionParams<Type.FileTypeDto>) => ({
    payload,
    url: "/api/admin/adminentityfiletypes/" + id,
    body,
  })
);
export const deleteFileTypeSaga = createAction(
  "DELETE_FILE_TYPES",
  ({ payload, id }: SagaActionParams<Type.FileTypeDto>) => ({
    payload,
    url: "/api/admin/adminentityfiletypes/" + id,
  })
);

const fileTypesSaga = [
  takeLatest<any>(
    getFileTypeListSaga.toString(),
    (payload: SagaGenericParams<Type.FileTypeDto[]>) =>
      getSaga<Type.FileTypeDto[]>(payload)
  ),
  takeLatest<any>(
    getFileTypeDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.FileTypeDetailDto>) =>
      getSaga<Type.FileTypeDetailDto>(payload)
  ),
  takeLatest<any>(
    createFileTypeSaga.toString(),
    (payload: SagaGenericParams<Type.FileTypeDto>) =>
      postSaga<Type.FileTypeDto>(payload)
  ),
  takeLatest<any>(
    updateFileTypeSaga.toString(),
    (payload: SagaGenericParams<Type.FileTypeDto>) =>
      putSaga<Type.FileTypeDto>(payload)
  ),
  takeLatest<any>(
    deleteFileTypeSaga.toString(),
    (payload: SagaGenericParams<any>) => deleteSaga<Type.FileTypeDto>(payload)
  ),
];

export default fileTypesSaga;
